import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "wf-bg-blue-50 wf-screen-fluid pb-6",
  id: "contacts"
}
const _hoisted_2 = { class: "wf-bg-yellow-50 wf-screen-fluid" }
const _hoisted_3 = { class: "wf-container px-3" }
const _hoisted_4 = { class: "flex wf-operators align-items-center " }
const _hoisted_5 = { class: "wf-container px-3" }
const _hoisted_6 = { class: "grid pt-3 justify-content-center" }
const _hoisted_7 = { class: "p-2 md:col-6 sm-12" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h2", { class: "mt-3 mb-0" }, "Контакты", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Информация, представленная на сайте, не является публичной офертой. ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Используя сайт, вы принимаете условия ")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("a", {
  class: "copyright",
  style: {"color":"#0af"},
  href: "https://well.ru/about/acceptance_personal_data.php"
}, " положения об обработке персональных данных пользователей", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" © «Сеть туристических агентств Велл». ")
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 2021. Все права защищены. ")
const _hoisted_20 = { class: "p-2 md:col-6 sm-12" }
const _hoisted_21 = /*#__PURE__*/_createVNode("h5", { class: "mb-2 mt-3" }, "Свяжитесь с нами", -1)
const _hoisted_22 = { class: "flex flex-wrap align-items-center" }
const _hoisted_23 = /*#__PURE__*/_createVNode("h5", { class: "mb-2 mt-3" }, "Мы в соцсетях", -1)
const _hoisted_24 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OfficeMap = _resolveComponent("OfficeMap")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_OfficeMap),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (n) => {
            return _createVNode("div", {
              key: n,
              class: "wf-operator"
            }, [
              _createVNode("img", {
                src: require(`@/assets/operator-${n}.png`),
                alt: ""
              }, null, 8, ["src"])
            ])
          }), 64))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("p", null, [
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _createVNode("img", {
              class: "wf-logo wf-logo-medium",
              style: {"width":"150px","margin-left":"-8px"},
              src: require('@/assets/well-small.svg')
            }, null, 8, ["src"]),
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode("p", null, _toDisplayString(_ctx.publicAddress), 1),
          _createVNode("div", _hoisted_22, [
            _createVNode("a", {
              class: "mr-2 mb-2 d-inline-flex wf-nodecoration",
              href: `tel:${_ctx.publicPhone}`
            }, [
              _createVNode(_component_Button, {
                icon: "pi pi-phone",
                label: _ctx.prettifyPhone(_ctx.publicPhone),
                class: "p-button-warning"
              }, null, 8, ["label"])
            ], 8, ["href"]),
            _createVNode(_component_Button, {
              label: _ctx.isMobile ? 'Заявка' : 'Оставить заявку',
              icon: "pi pi-envelope",
              class: "mr-2 mb-2",
              onClick: _ctx.proceedToOrder
            }, null, 8, ["label", "onClick"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.socials.filter((s) => s.isMessenger), (social) => {
              return (_openBlock(), _createBlock("a", {
                key: social.title,
                href: social.src,
                target: "_blank",
                class: "wf-social mr-2 mb-2"
              }, [
                _createVNode("img", {
                  src: require(`@/assets/${social.icon}`)
                }, null, 8, ["src"])
              ], 8, ["href"]))
            }), 128))
          ]),
          _hoisted_23,
          _createVNode("div", _hoisted_24, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.socials.filter((s) => !s.isMessenger), (social) => {
              return (_openBlock(), _createBlock("a", {
                key: social.title,
                class: "wf-social mr-2 mb-2",
                href: social.src,
                target: "_blank"
              }, [
                _createVNode("img", {
                  src: require(`@/assets/${social.icon}`)
                }, null, 8, ["src"])
              ], 8, ["href"]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}